// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "INVOICE_ITEM",
    ENTITY_NAME: "invoiceItem",
    RESOURCE: "invoice-items",
};
